module.exports = __webpack_public_path__ + "static/media/topBg.ac3c7429.png";